import { SAVE_ORGANISATIONS_INFO } from './actionTypes';
import { get } from '../utils/communications';
import { apiEndpoint } from '../utils/env';
import organisationsSchema from '../normalizr-schemas/organisationSchema';

const saveOrganisationsInfo = organisations => ({
  type: SAVE_ORGANISATIONS_INFO,
  payload: {
    organisations,
  },
});

export const getOrganisationsInfo = organisations => dispatch => (
  get(`${apiEndpoint}/organisations/info`, organisationsSchema, false, { organisationId: organisations })
    .then(resp => dispatch(saveOrganisationsInfo(resp.data)))
    .catch((err) => { throw err; })
);



// WEBPACK FOOTER //
// ./src/actions/organisation.js